export default function normalizeSpaceVariations(value) {
  let allowedCharacters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ["'"];
  let disallowedCharacters = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  const nonWordRegex = new RegExp(`(?:(?![${allowedCharacters.join('')}])[\\W_])+`, 'g');
  const deleteCharsRegex = new RegExp(`[${disallowedCharacters}]+`, 'g');

  //  normalize value down to essential content so we can attempt to fuzzy match values
  return decodeURI(value) // decode any url encoded chars
  .replace(deleteCharsRegex, '') // remove characters in delete list
  .replace(nonWordRegex, ' ') // replace any non word characaters, dashes, and periods with a space
  .replace(/\s\s+/g, ' ') // replace any multiple spaces with a single space
  .trim() // trim to remove any trailing spaces
  .toLowerCase(); // lowercase to make sure they all are playing nice
}